import { render, staticRenderFns } from "./Delinquent.vue?vue&type=template&id=389c8871&scoped=true&"
import script from "./Delinquent.vue?vue&type=script&lang=ts&"
export * from "./Delinquent.vue?vue&type=script&lang=ts&"
import style0 from "./Delinquent.vue?vue&type=style&index=0&id=389c8871&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c8871",
  null
  
)

export default component.exports